"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var react_multi_carousel_1 = __importDefault(require("react-multi-carousel"));

require("react-multi-carousel/lib/styles.css");

var utils_1 = require("../../../../utils");

var Header_1 = __importDefault(require("../../../Card/Header"));

var Book_1 = __importDefault(require("../Book"));

var responsive_1 = __importDefault(require("./responsive"));

require("./style.scss");
/**
* Container Component to view `LibraryBook`s.
*/


var LibraryShelf = function LibraryShelf(_a) {
  var graphic = _a.graphic,
      items = _a.items,
      onSelect = _a.onSelect,
      style = _a.style,
      title = _a.title;

  var key = function key(label, index) {
    return "lbi-" + label + "-" + index;
  };

  var handleClickBook = function handleClickBook(book) {
    return onSelect ? function () {
      return onSelect(book);
    } : undefined;
  };

  var renderBooks = function renderBooks(books) {
    return books.map(function (book, index) {
      var _a = book.color,
          color = _a === void 0 ? {
        accent: undefined,
        cover: undefined,
        text: undefined
      } : _a,
          contribution = book.contribution,
          instance = book.instance,
          label = book.label;
      var accent = color.accent,
          cover = color.cover,
          text = color.text;
      return react_1.default.createElement(Book_1.default, {
        key: key(label, index),
        onClick: handleClickBook(book),
        title: label,
        subtitle: instance,
        detail: "Contribution: " + contribution,
        accentColor: accent,
        coverColor: cover,
        textColor: text
      });
    });
  };

  var carousels = [];
  (0, utils_1.chunk)(items, 10, function (itemChunk) {
    var isSmallCarousel = itemChunk.length < responsive_1.default.tablet.items;
    carousels.push(react_1.default.createElement(react_multi_carousel_1.default, {
      arrows: !isSmallCarousel,
      autoPlay: !isSmallCarousel,
      autoPlaySpeed: 9000 + Math.floor(Math.random() * 2000),
      containerClass: "story-library-shelf__carousel",
      draggable: !isSmallCarousel,
      infinite: !isSmallCarousel,
      key: "carousel-" + title + "-" + Math.random(),
      keyBoardControl: true,
      responsive: responsive_1.default,
      ssr: true,
      swipeable: !isSmallCarousel
    }, renderBooks(itemChunk)));

    if (graphic) {
      carousels.push(react_1.default.createElement("div", {
        className: "story-library-shelf__graphic",
        key: "carousel-" + title + "-graphic-" + Math.random()
      }, react_1.default.createElement("img", {
        alt: "Library Shelf",
        src: graphic.url
      })));
    }
  });
  return react_1.default.createElement("div", {
    className: "story-library-shelf",
    style: style
  }, react_1.default.createElement(Header_1.default, {
    text: title
  }), carousels);
};

LibraryShelf.propTypes = {
  /** Determines what media asset to render under the `Carousel` */
  graphic: prop_types_1.default.shape({
    url: prop_types_1.default.string.isRequired
  }),

  /** Data to render `LibraryBook` props */
  items: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,

  /** Click handler callback used by the `LibraryShelf` */
  onSelect: prop_types_1.default.func,

  /** Styling object of the `Shelf` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object,

  /** Header text to place above the `Shelf` */
  title: prop_types_1.default.string
};
LibraryShelf.defaultProps = {
  graphic: undefined,
  onSelect: function onSelect() {},
  style: {},
  title: ''
};
exports.default = LibraryShelf;